// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IAnnouncementTargetObjectModel } from '../TargetObjects/AnnouncementTargetObjectModel';

export interface IGetPublishTermsRequest {
  /** ID объявления (если 0, то будут использоваться параметры locationPath, category, photosCount) **/
  id: number;
  /**
   * LocationPath для определения региона, по которому будем вычислять стоимость размещения
   * Child-to-parent ids (175578,6166,4593 - для Московская область, район Одинцово, Одинцово)
   */
  locationPath?: number[];
  /** Категория для публикации объявления (Аренда квартиры, Продажа дома), по которому будем вычислять стоимость размещения **/
  category?: ECategory;
  /** Количество фотографий у объявления (влияет на доступность типа размещения ТОП-3) **/
  photosCount?: number;
  /** Ид ТЦ/БЦ **/
  businessShoppingCenterId?: number;
  /** Ид новостройки **/
  newObjectId?: number;
  /** Широта. **/
  latitude?: number;
  /** Долгота. **/
  longitude?: number;
  /**
   * Для кого запрашиваются услуги
   * true - Собственник
   * false - Агент
   */
  isByHomeowner?: boolean;
  /** Возможность использовать объект по частям **/
  isMultiListing?: boolean;
  /** Источник средств **/
  moneySource?: EMoneySource;
  /** Дата для которой выбираются тарифы **/
  dateAction?: string;
  /** Стоимость в объявлении. **/
  price?: number;
  /** Валюта **/
  currency?: ECurrency;
  /** Тип цены **/
  priceType?: EPriceType;
  /** Период оплаты **/
  paymentPeriod?: EPaymentPeriod;
  /** Общая площадь. **/
  totalArea?: number;
  /** Количество слотов в мультиобъявлении. **/
  multiListingSlotsCount?: number;
  /** Тип фронтенда в запросе **/
  uiType?: EUiType;
  /** Источник отображения ФВУ **/
  hostName?: EHostName;
  extraData?: IAnnouncementTargetObjectModel;
  /** Если пользователь выбрал способ размещения за счёт пакета на UI ФВУ. **/
  isPackageOnUi?: boolean;
  /** Объявление из импорта **/
  isUpload?: boolean;
  /** Услуга размещения **/
  publicationToken?: string;
}
export enum ECategory {
  /** Койко-место **/
  'BedRent' = 'bedRent',
  /** Здание **/
  'BuildingRent' = 'buildingRent',
  /** Здание **/
  'BuildingSale' = 'buildingSale',
  /** Готовый бизнес **/
  'BusinessRent' = 'businessRent',
  /** Готовый бизнес **/
  'BusinessSale' = 'businessSale',
  /** Аренда автосервис **/
  'CarServiceRent' = 'carServiceRent',
  /** Продажа автосервиса **/
  'CarServiceSale' = 'carServiceSale',
  /** Коммерческая земля **/
  'CommercialLandRent' = 'commercialLandRent',
  /** Коммерческая земля **/
  'CommercialLandSale' = 'commercialLandSale',
  /** Коттедж **/
  'CottageRent' = 'cottageRent',
  /** Коттедж **/
  'CottageSale' = 'cottageSale',
  /** Посуточная аренда койко-места **/
  'DailyBedRent' = 'dailyBedRent',
  /** Посуточная аренда квартиры **/
  'DailyFlatRent' = 'dailyFlatRent',
  /** Посуточная аренда дома, дачи, коттеджа **/
  'DailyHouseRent' = 'dailyHouseRent',
  /** Посуточная аренда комнаты **/
  'DailyRoomRent' = 'dailyRoomRent',
  /** Аренда помещения под бытовые услуги **/
  'DomesticServicesRent' = 'domesticServicesRent',
  /** Продажа помещения под бытовые услуги **/
  'DomesticServicesSale' = 'domesticServicesSale',
  /** Квартира **/
  'FlatRent' = 'flatRent',
  /** Квартира **/
  'FlatSale' = 'flatSale',
  /** Доля в квартире **/
  'FlatShareSale' = 'flatShareSale',
  /** Помещение свободного назначения **/
  'FreeAppointmentObjectRent' = 'freeAppointmentObjectRent',
  /** Помещение свободного назначения **/
  'FreeAppointmentObjectSale' = 'freeAppointmentObjectSale',
  /** Гараж **/
  'GarageRent' = 'garageRent',
  /** Гараж **/
  'GarageSale' = 'garageSale',
  /** Дом/дача **/
  'HouseRent' = 'houseRent',
  /** Дом/дача **/
  'HouseSale' = 'houseSale',
  /** Часть дома **/
  'HouseShareRent' = 'houseShareRent',
  /** Часть дома **/
  'HouseShareSale' = 'houseShareSale',
  /** Производство **/
  'IndustryRent' = 'industryRent',
  /** Производство **/
  'IndustrySale' = 'industrySale',
  /** Участок **/
  'LandSale' = 'landSale',
  /** Квартира в новостройке **/
  'NewBuildingFlatSale' = 'newBuildingFlatSale',
  /** Офис **/
  'OfficeRent' = 'officeRent',
  /** Офис **/
  'OfficeSale' = 'officeSale',
  /** Аренда общепита **/
  'PublicCateringRent' = 'publicCateringRent',
  /** Продажа общепита **/
  'PublicCateringSale' = 'publicCateringSale',
  /** Комната **/
  'RoomRent' = 'roomRent',
  /** Комната **/
  'RoomSale' = 'roomSale',
  /** Торговая площадь **/
  'ShoppingAreaRent' = 'shoppingAreaRent',
  /** Торговая площадь **/
  'ShoppingAreaSale' = 'shoppingAreaSale',
  /** Таунхаус **/
  'TownhouseRent' = 'townhouseRent',
  /** Таунхаус **/
  'TownhouseSale' = 'townhouseSale',
  /** Склад **/
  'WarehouseRent' = 'warehouseRent',
  /** Склад **/
  'WarehouseSale' = 'warehouseSale',
}
export enum EMoneySource {
  /** Собственные средства **/
  'Self' = 'self',
  /** Средства агентства **/
  'Master' = 'master',
}
export enum ECurrency {
  /** Евро **/
  'Eur' = 'eur',
  /** Рубль **/
  'Rur' = 'rur',
  /** Доллар **/
  'Usd' = 'usd',
}
export enum EPriceType {
  /** Цена за все **/
  'All' = 'all',
  /** Цена за квадратный метр **/
  'SquareMeter' = 'squareMeter',
  /** Сотка **/
  'Sotka' = 'sotka',
  /** Гектар **/
  'Hectare' = 'hectare',
}
export enum EPaymentPeriod {
  /** За год **/
  'Annual' = 'annual',
  /** За месяц **/
  'Monthly' = 'monthly',
}
export enum EUiType {
  /** Веб-сайт, в т.ч. мобильный **/
  'Desktop' = 'desktop',
  /** Веб-вью мобильного приложения **/
  'WebView' = 'webView',
}
export enum EHostName {
  /** Мои объявления **/
  'MyOffers' = 'myOffers',
  /** Новая форма подачи **/
  'NewAddForm' = 'newAddForm',
  /** Форма подачи **/
  'AddForm' = 'addForm',
}
